import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { lazyReducerEnhancer } from 'pwa-helpers/lazy-reducer-enhancer'
import { slice as profile } from '../slices/profile'

// NOTE: Define static reducers that must always be present in the application.
// Most slice reducers are best to be lazy-added to the store by the consumer.
// Be careful to only add static slice reducers that are system-wide.
const staticReducers = {
  [profile.name]: profile.reducer
}

const store = configureStore({
  reducer: (state = {}) => state,
  enhancers: [lazyReducerEnhancer(combineReducers)]
})

if (Object.keys(staticReducers).length) {
  store.addReducers(staticReducers)
}

export default store
